exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".report-wrapper {\n    position: fixed;\n    z-index: 9999;\n    bottom: 0;\n    left: 50%;\n\n    -webkit-box-sizing: border-box;\n\n            box-sizing: border-box;\n    width: 500px;\n    min-height: 56px;\n    margin-left: -250px;\n    padding: 16px 21px;\n\n    border-radius: 3px 3px 0 0;\n    background-color: #d0021b;\n\n    font-family: Roboto, sans-serif;\n    line-height: 24px;\n}\n\n.report--inner {\n    opacity: 1;\n    color: rgb(255, 255, 255);\n\n    font-size: 14px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"importLoaders":1}!./~/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/components/reportEditing/reportEditing.css
// module id = ./node_modules/css-loader/index.js?{"importLoaders":1}!./node_modules/postcss-loader/lib/index.js?{"ident":"postcss","plugins":[null,null]}!./src/components/reportEditing/reportEditing.css
// module chunks = 0